var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":_vm.itemDefinition.title,"back-link":"back"}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":`${_vm.ImageUrlBuilder.url64(_vm.itemDefinition.detailImgUrl, _vm.storeId)}`}}),_c('div',[_vm._v(_vm._s(_vm.itemDefinition.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }